module.exports = __webpack_public_path__ + "img/cqfw6.ac7b14aa.png";